import Vue from "vue"
import VueRouter from "vue-router"
Vue.use(VueRouter);

const routes = [
	{
		path: "/login",
		name: "",
		component: () => import('@/pages/Login'),
		meta: {
			requiresAuth: false
		},
	},
	{
		path: "/pay",
		name: "支付",
		component: () => import('@/pages/pay/pay'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/",
		name: "开票",
		redirect: '/index'
	},
	{
		path: "/index",
		name: "开票",
		component: () => import('@/pages/Index'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/set",
		name: "个人信息",
		component: () => import('@/pages/Set'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/home/address",
		name: "地址簿",
		component: () => import('@/pages/home/address/address'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/home/address/add",
		name: "添加地址",
		component: () => import('@/pages/home/address/add'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/home/address/edit",
		name: "添加地址",
		component: () => import('@/pages/home/address/edit'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/home/title",
		name: "开票抬头",
		component: () => import('@/pages/home/title/title'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/home/title/add",
		name: "添加开票抬头",
		component: () => import('@/pages/home/title/add'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/home/title/edit",
		name: "编辑",
		component: () => import('@/pages/home/title/edit'),
		meta: {
			requiresAuth: true
		},
	},
	
	{
		path: "/home/project",
		name: "工程管理",
		component: () => import('@/pages/home/project/project'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/home/project/add",
		name: "添加工程",
		component: () => import('@/pages/home/project/add'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/home/project/detail",
		name: "工程详情",
		component: () => import('@/pages/home/project/detail'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/invoice/gth",
		name: "开票",
		component: () => import('@/pages/invoice/gth'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/invoice/add",
		name: "开票",
		component: () => import('@/pages/invoice/add'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/invoice/list",
		name: "我的开票",
		component: () => import('@/pages/invoice/List'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/invoice/details",
		name: "开票详情",
		component: () => import('@/pages/invoice/Details'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/invoice/uploader_cash",
		name: "上传流水凭证",
		component: () => import('@/pages/invoice/uploader_cash'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/invoice/uploader_contract",
		name: "上传合同凭证",
		component: () => import('@/pages/invoice/uploader_contract'),
		meta: {
			requiresAuth: true
		},
	},
	{
		path: "/invoice/uploader_evidence",
		name: "上传业务凭证",
		component: () => import('@/pages/invoice/uploader_evidence'),
		meta: {
			requiresAuth: true
		}
	}
]
const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
	document.title = to.name;
	if (to.meta.requiresAuth) {
		if (localStorage.getItem('sid')) {
			next();
		} else {
			next({
				path: "/login",
				query: {
					redirect: to.fullPath
				}
			});
		}
	} else {
		next();
	}
})
export default router;